import { CardType } from 'types/deck'
import { DeckCard } from 'services/apiTypes/deck.types'
import shortid from 'shortid'

function mapToDeck(map: Record<string, CardType>): DeckCard[] {
  const cards: DeckCard[] = Object.keys(map).map(cardId => {
    const card = map[cardId]

    return {
      card: {
        id: Number(card.cardId) || shortid.generate(),
        cardId: Number(card.cardId),
        edition: {
          editioncode: card.setCode,
          editionname: card.set,
          mtgoCode: card.mtgoCode,
        },
        artist: card.artist,
        rarity: card.rarity,
        options: card.options,
        multiverseid: card.multiverseid,
        flavor: card.flavor,
        prices: {
          ck: card.prices.ck,
          ckfoil: card.prices.ckFoil,
          tcg: card.prices.tcg,
          tcgfoil: card.prices.tcgFoil,
          mtgo: card.prices.mtgo,
          mtgofoil: card.prices.mtgoFoil,
          cm: card.prices.cm,
          cmfoil: card.prices.cmFoil,
          scg: card.prices.scg,
          scgfoil: card.prices.scgFoil,
          mp: card.prices.mp,
          mpfoil: card.prices.mpFoil,
          tcgland: card.prices.tcgLand,
          tcglandfoil: card.prices.tcgLandFoil,
        },
        uid: card.uid,
        oracleCard: {
          colors: card.colors,
          colorIdentity: card.colorIdentity,
          types: card.types,
          subTypes: card.subTypes,
          superTypes: card.superTypes,
          legalities: card.legalities,
          name: card.name,
          manaCost: '',
          cmc: card.cmc,
          text: card.text,
          power: card.power,
          toughness: card.toughness,
          layout: card.layout,
          faces: card.faces,
          manaProduction: card.manaProduction,
          salt: card.salt,
          edhrecRank: card.edhrecRank,
          tokens: card.tokens,
        },
        owned: card.owned,
        collectorNumber: card.collectorNumber,
        // These must just get tossed out somewhere in the response cause it's not here
        tcgProductId: -1,
        ckNormalId: -1,
        ckFoilId: -1,
        mtgoNormalId: -1,
        mtgoFoilId: -1,
        games: [],
        cmEd: '',
      },
      quantity: card.qty,
      modifier: card.modifier,
      category: '',
      categories: card.categories,
      label: `${card.colorLabel.name},${card.colorLabel.color}`,
      id: card.deckRelationId,
    }
  })

  return cards
}

export default mapToDeck
